import { useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import Badge from '@App/components/Badge/Badge'
import BtnGrid from '@App/components/BtnGrid/BtnGrid'
import BtnList from '@App/components/BtnList/BtnList'
import IconBtnHor from '@App/components/IconBtnHor/IconBtnHor'

import './type-toggles.styl'

function TypeToggles({ types, activeTypeIds, setActiveTypeIds, layout = 'grid', badge = true, badgeShape = 'circle' }) {
  const dispatch = useDispatch()

  const toggleTypes = useCallback((newActiveTypeIds) => {
    dispatch(setActiveTypeIds(newActiveTypeIds))
  }, [dispatch, setActiveTypeIds])

  useEffect(() => {
    if (activeTypeIds === undefined && types && types.length > 0) {
      const allTypeIds = types.filter(type => type.default).map(type => type.id)
      toggleTypes(allTypeIds)
    }
  }, [toggleTypes, activeTypeIds, types])

  const LayoutWrapper = layout === 'grid' ? BtnGrid : BtnList

  if (!types || types.length === 0 || !activeTypeIds) return null

  return (
    <LayoutWrapper>
      {types.map((curr) => {
        const { id, group, icon, label, color } = curr
        const active = activeTypeIds.includes(id)

        return (
          <IconBtnHor
            key={id}
            iconProps={{
              icon: `/img/icons/types/${group}/${icon}.svg`,
              size: '22px',
            }}
            badge={badge ? <Badge type="danger" color={color} shape={badgeShape} /> : null}
            inactive={!active}
            onClick={() => {
              const newActiveTypeIds = active ? activeTypeIds.filter(curr => curr !== id) : [...activeTypeIds, id]

              toggleTypes(newActiveTypeIds)
            }}
          >
            <span>{label}</span>
            {curr?.amount != null && (
              <span style={{ fontWeight: 'bold', fontSize: '14px', marginRight: '10px' }}>{curr.amount}</span>
            )}
            {(curr?.positive || curr?.negative) && (
              <div className="type-toggles__numbers">
                {curr?.positive && (
                  <span className="type-toggles__numbers__positive">
                    {`${curr?.positive} positive`}
                  </span>
                )}
                {curr?.negative && (
                  <span className="type-toggles__numbers__negative">
                    {`${curr?.negative} negative`}
                  </span>
                )}
              </div>
            )}
          </IconBtnHor>
        )
      })}
    </LayoutWrapper>
  )
}

export default TypeToggles
